import { useLayoutEffect, useState, useSyncExternalStore } from "react";
import { VirtualRowsStore, type TableVirtualOptions } from "./virtualRowsStore";

export function useMeasuredVirtualRows(options: TableVirtualOptions) {
  const [store] = useState(() => new VirtualRowsStore(options));
  const snapshot = useSyncExternalStore(store.subscribe, store.getSnapshot, store.getSnapshot);
  useLayoutEffect(() => store.mount(), [store]);
  useLayoutEffect(() => {
    store.update(options);
  });

  return {
    // A changed row list commits before its new measurements; never render an
    // index removed by that same commit while the layout update catches up.
    virtualRows: snapshot.rows.filter((row) => row.index < options.count),
    virtualTotalSize: snapshot.totalSize,
    measureVirtualRow: store.measureElement,
  };
}
